import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import CategorizedPermissionsDisplay from "../CategorizedPermissionsDisplay";

const categorizePermissions = (permissions) => {
  const readPermissions = [];
  const writePermissions = [];
  if (permissions) {
    permissions.forEach((permission) => {
      if (permission.includes(".Read")) {
        readPermissions.push(permission);
      }
      if (permission.includes(".Write") || permission.includes(".ReadWrite")) {
        writePermissions.push(permission);
      }
      if (permission === "user_impersonation") {
        readPermissions.push(permission);
        writePermissions.push(permission);
      }
    });
  }
  return { readPermissions, writePermissions };
};

const MicrosoftEntraIDApplicationDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.microsoft_entra_id_application_data?.app_description && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>App Description</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.microsoft_entra_id_application_data?.app_description
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.microsoft_entra_id_application_data?.scopes?.length > 0 &&
        (() => {
          const { readPermissions, writePermissions } = categorizePermissions(
            entityData.microsoft_entra_id_application_data.scopes
          );
          return (
            <CategorizedPermissionsDisplay
              readPermissions={readPermissions}
              writePermissions={writePermissions}
            />
          );
        })()}
      {entityData?.microsoft_entra_id_application_data
        ?.password_credentials && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Client Secret Exists</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.microsoft_entra_id_application_data
                  ?.password_credentials &&
                Object.keys(
                  entityData.microsoft_entra_id_application_data
                    .password_credentials
                ).length > 0
                  ? "True"
                  : "False"
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.microsoft_entra_id_application_data?.key_credentials && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>
              Certificate Authentication Exists
            </Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.microsoft_entra_id_application_data
                  ?.key_credentials &&
                Object.keys(
                  entityData.microsoft_entra_id_application_data.key_credentials
                ).length > 0
                  ? "True"
                  : "False"
              }
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MicrosoftEntraIDApplicationDetailsView;
